import { createRouter, createWebHashHistory, RouteRecordRaw } from "vue-router";
import Home from "../views/Home.vue";

// history 关键字：createWebHistory
// hash 关键字：createWebHashHistory

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: {
      title: "科普科研成果展示平台",
      content: {
        keywords:
          "科普科研成果展示平台；教育研究；科技探索；健康科普；大中小学思政课一体化；美育融合；未成年人心理健康教育；学校高质量发展",
        description:
          "科普科研成果展示平台是集科普科研成果交流展示、科普科研动态发布、成果孵化矩阵建设、科普科研领域专家智库建设等功能于一体的数字化展示平台，聚焦教育研究、科技探索、健康科普、大中小学思政课一体化、美育融合、未成年人心理健康教育、学校高质量发展等领域，以系列成熟、有影响力的品牌期刊、专辑，服务全国科普科研工作者，为广大科普科研开辟在线成果展示空间。",
      },
    },
  },
  // 活动专区列表页
  {
    path: "/hdzq/list",
    name: "hdzqList",
    component: () => import("@/views/hdzq/list.vue"),
    meta: {
      title: "活动专区",
      content: {
        keywords:
          "研究动态，实践动态",
        description:
          "",
      },
    },
  },
  {
    path: "/hdzq/detail",
    name: "hdzqDetail",
    component: () => import("@/views/hdzq/detail.vue"),
    meta: {
      title: "",
      content: {
        keywords:
          "研究动态；实践动态",
        description:
          "",
      },
    },
  },
  {
    path: "/hdzq/newhdzshd",
    name: "hdzqNewhdzshd",
    component: () => import("@/views/hdzq/xinhuodongzshd.vue"),
    meta: {
      title: "",
      content: {
        keywords:
          "研究动态；实践动态",
        description:
          "",
      },
    },
  },
  {
    path: "/hdzq/gydjt",
    name: "hdzqGydjt",
    component: () => import("@/views/hdzq/xinhuodonggydjt.vue"),
    meta: {
      title: "",
      content: {
        keywords:
          "研究动态；实践动态",
        description:
          "",
      },
    },
  },
  // 通用文章列表页
  {
    path: "/paper/list",
    name: "paperList",
    component: () => import("@/views/paperlist/list.vue"),
    meta: {
      title: "成果展示",
      content: {
        keywords:
          "",
        description:
          "",
      },
    },
  },
  // 思政一体首页
  {
    path: "/szyt/list",
    name: "szytList",
    component: () => import("@/views/szyt/list.vue"),
    meta: {
      title: "思政一体",
      content: {
        keywords:
          "",
        description:
          "",
      },
    },
  },
  // 思政一体期详情页
  {
    path: "/szyt/index",
    name: "szytIndex",
    component: () => import("@/views/szyt/index.vue"),
    meta: {
      title: "思政一体",
      content: {
        keywords:
          "",
        description:
          "",
      },
    },
  },
  // 思政一体版面概览
  {
    path: "/szyt/bmgl",
    name: "szytBmgl",
    component: () => import("@/views/szyt/banmiangailan.vue"),
    meta: {
      title: "思政一体",
      content: {
        keywords:
          "",
        description:
          "",
      },
    },
  },
  // 心理聚焦首页
  {
    path: "/xljj/list",
    name: "xljjList",
    component: () => import("@/views/xljj/list.vue"),
    meta: {
      title: "心理聚焦",
      content: {
        keywords:
          "",
        description:
          "",
      },
    },
  },
  // 心理聚焦期详情页
  {
    path: "/xljj/index",
    name: "xljjIndex",
    component: () => import("@/views/xljj/index.vue"),
    meta: {
      title: "心理聚焦",
      content: {
        keywords:
          "",
        description:
          "",
      },
    },
  },
  // 心理聚焦版面概览
  {
    path: "/xljj/bmgl",
    name: "xljjBmgl",
    component: () => import("@/views/xljj/banmiangailan.vue"),
    meta: {
      title: "心理聚焦",
      content: {
        keywords:
          "",
        description:
          "",
      },
    },
  },
  // 学校发展首页
  {
    path: "/xxfz/list",
    name: "xxfzList",
    component: () => import("@/views/xxfz/list.vue"),
    meta: {
      title: "学校发展",
      content: {
        keywords:
          "",
        description:
          "",
      },
    },
  },
  // 学校发展期详情页
  {
    path: "/xxfz/index",
    name: "xxfzIndex",
    component: () => import("@/views/xxfz/index.vue"),
    meta: {
      title: "学校发展",
      content: {
        keywords:
          "",
        description:
          "",
      },
    },
  },
  // 学校发展版面概览
  {
    path: "/xxfz/bmgl",
    name: "xxfzBmgl",
    component: () => import("@/views/xxfz/banmiangailan.vue"),
    meta: {
      title: "学校发展",
      content: {
        keywords:
          "",
        description:
          "",
      },
    },
  },
  // 教育研究首页
  {
    path: "/jyyj/list",
    name: "jyyjList",
    component: () => import("@/views/jyyj/list.vue"),
    meta: {
      title: "教育研究",
      content: {
        keywords:
          "",
        description:
          "",
      },
    },
  },
  // 教育研究期刊详情页
  {
    path: "/jyyj/index",
    name: "jyyjIndex",
    component: () => import("@/views/jyyj/index.vue"),
    meta: {
      title: "教育研究",
      content: {
        keywords:
          "",
        description:
          "",
      },
    },
  },
  // 教育研究期刊版面概览
  {
    path: "/jyyj/bmgl",
    name: "jyyjBmgl",
    component: () => import("@/views/jyyj/banmiangailan.vue"),
    meta: {
      title: "教育研究",
      content: {
        keywords:
          "",
        description:
          "",
      },
    },
  },
  // 教育研究期刊文章内容页
  {
    path: "/jyyj/wzxq",
    name: "jyyjWzxq",
    component: () => import("@/views/jyyj/detail.vue"),
    meta: {
      title: "教育研究",
      content: {
        keywords:
          "",
        description:
          "",
      },
    },
  },
  // 健康科普首页
  {
    path: "/jkkp/list",
    name: "jkkpList",
    component: () => import("@/views/jkkp/list.vue"),
    meta: {
      title: "健康科普",
      content: {
        keywords:
          "重庆日报报业集团；重庆课堂内外杂志社出版有限公司；重庆立合印务有限公司；重庆新女报传媒有限公司",
        description:
          "《健康人报》创办于2000年，是由重庆日报报业集团主管、新女报传媒主办、《健康人报》编辑部编辑出版的面向全国公开发行的大众健康类周报。刊物自创办以来，聚焦卫生健康等领域，积极搭建卫生科普宣传的阵地与平台，组建由相关领域专家和学者出任顾问和委员的编委会，是全国重点健康类报纸。",
      },
    },
  },
  // 健康科普期刊详情页面
  {
    path: "/jkkp/index",
    name: "jkkpIndex",
    component: () => import("@/views/jkkp/index.vue"),
    meta: {
      title: "健康科普",
      content: {
        keywords:
          "重庆日报报业集团；重庆课堂内外杂志社出版有限公司；重庆立合印务有限公司；重庆新女报传媒有限公司",
        description:
          "《健康人报》创办于2000年，是由重庆日报报业集团主管、新女报传媒主办、《健康人报》编辑部编辑出版的面向全国公开发行的大众健康类周报。刊物自创办以来，聚焦卫生健康等领域，积极搭建卫生科普宣传的阵地与平台，组建由相关领域专家和学者出任顾问和委员的编委会，是全国重点健康类报纸。",
      },
    },
  },
  // 健康科普期刊版面概览
  {
    path: "/jkkp/bmgl",
    name: "jkkpBmgl",
    component: () => import("@/views/jkkp/banmiangailan.vue"),
    meta: {
      title: "健康科普",
      content: {
        keywords:
          "重庆日报报业集团；重庆课堂内外杂志社出版有限公司；重庆立合印务有限公司；重庆新女报传媒有限公司",
        description:
          "《健康人报》创办于2000年，是由重庆日报报业集团主管、新女报传媒主办、《健康人报》编辑部编辑出版的面向全国公开发行的大众健康类周报。刊物自创办以来，聚焦卫生健康等领域，积极搭建卫生科普宣传的阵地与平台，组建由相关领域专家和学者出任顾问和委员的编委会，是全国重点健康类报纸。",
      },
    },
  },
  // 科技探索首页
  {
    path: "/kjts/list",
    name: "kjtsList",
    component: () => import("@/views/kjts/list.vue"),
    meta: {
      title: "科技探索",
      content: {
        keywords:
          "重庆日报报业集团；重庆课堂内外杂志社出版有限公司；重庆立合印务有限公司；重庆新女报传媒有限公司",
        description:
          "《健康人报》创办于2000年，是由重庆日报报业集团主管、新女报传媒主办、《健康人报》编辑部编辑出版的面向全国公开发行的大众健康类周报。刊物自创办以来，聚焦卫生健康等领域，积极搭建卫生科普宣传的阵地与平台，组建由相关领域专家和学者出任顾问和委员的编委会，是全国重点健康类报纸。",
      },
    },
  },
  // 科技探索期刊详情页面
  {
    path: "/kjts/index",
    name: "kjtsIndex",
    component: () => import("@/views/kjts/index.vue"),
    meta: {
      title: "科技探索",
      content: {
        keywords:
          "重庆日报报业集团；重庆课堂内外杂志社出版有限公司；重庆立合印务有限公司；重庆新女报传媒有限公司",
        description:
          "《健康人报》创办于2000年，是由重庆日报报业集团主管、新女报传媒主办、《健康人报》编辑部编辑出版的面向全国公开发行的大众健康类周报。刊物自创办以来，聚焦卫生健康等领域，积极搭建卫生科普宣传的阵地与平台，组建由相关领域专家和学者出任顾问和委员的编委会，是全国重点健康类报纸。",
      },
    },
  },
  // 科技探索期刊版面概览
  {
    path: "/kjts/bmgl",
    name: "kjtsBmgl",
    component: () => import("@/views/kjts/banmiangailan.vue"),
    meta: {
      title: "科技探索",
      content: {
        keywords:
          "重庆日报报业集团；重庆课堂内外杂志社出版有限公司；重庆立合印务有限公司；重庆新女报传媒有限公司",
        description:
          "《健康人报》创办于2000年，是由重庆日报报业集团主管、新女报传媒主办、《健康人报》编辑部编辑出版的面向全国公开发行的大众健康类周报。刊物自创办以来，聚焦卫生健康等领域，积极搭建卫生科普宣传的阵地与平台，组建由相关领域专家和学者出任顾问和委员的编委会，是全国重点健康类报纸。",
      },
    },
  },
  // 报纸类文章详情
  {
    path: "/jkkp/wzxq",
    name: "jkkpWzxq",
    component: () => import("@/views/jkkp/detail.vue"),
    meta: {
      title: "健康科普",
      content: {
        keywords:
          "重庆日报报业集团；重庆课堂内外杂志社出版有限公司；重庆立合印务有限公司；重庆新女报传媒有限公司",
        description:
          "《健康人报》创办于2000年，是由重庆日报报业集团主管、新女报传媒主办、《健康人报》编辑部编辑出版的面向全国公开发行的大众健康类周报。刊物自创办以来，聚焦卫生健康等领域，积极搭建卫生科普宣传的阵地与平台，组建由相关领域专家和学者出任顾问和委员的编委会，是全国重点健康类报纸。",
      },
    },
  },
  // 报纸类文章详情h5
  {
    path: "/jkkp/wzxqh5",
    name: "jkkpWzxqh5",
    component: () => import("@/views/jkkp/detailh5.vue"),
    meta: {
      title: "健康科普",
      content: {
        keywords:
          "重庆日报报业集团；重庆课堂内外杂志社出版有限公司；重庆立合印务有限公司；重庆新女报传媒有限公司",
        description:
          "《健康人报》创办于2000年，是由重庆日报报业集团主管、新女报传媒主办、《健康人报》编辑部编辑出版的面向全国公开发行的大众健康类周报。刊物自创办以来，聚焦卫生健康等领域，积极搭建卫生科普宣传的阵地与平台，组建由相关领域专家和学者出任顾问和委员的编委会，是全国重点健康类报纸。",
      },
    },
  },
  // 专家队伍列表
  {
    path: "/zjdw/list",
    name: "zjdwList",
    component: () => import("@/views/zjdw/list.vue"),
    meta: {
      title: "专家队伍",
      content: {
        keywords:
          "专家队伍",
        description:
          "",
      },
    },
  },
  // 专家队伍详情
  {
    path: "/zjdw/detail",
    name: "zjdwDetail",
    component: () => import("@/views/zjdw/detail.vue"),
    meta: {
      title: "专家队伍",
      content: {
        keywords:
          "专家队伍",
        description:
          "",
      },
    },
  },
  // 搜索列表页
  {
    path: "/search/list",
    name: "searchList",
    component: () => import("@/views/search/list.vue"),
    meta: {
      title: "搜索结果",
    },
  },
  // 投稿入口
  {
    path: "/tgrk",
    name: "tgrk",
    component: () => import("@/views/tgrk/index.vue"),
    meta: {
      title: "投稿入口",
    },
  },
  // 平台介绍
  {
    path: "/ptjs",
    name: "ptjs",
    component: () => import("@/views/ptjs/index.vue"),
    meta: {
      title: "平台介绍",
    },
  },
   // 登录
   {
    path: "/login",
    name: "/login",
    component: () => import("@/views/user/login.vue"),
    meta: {
      title:
        "登录",
    },
  },
  // 注册
  {
    path: "/reg",
    name: "/reg",
    component: () => import("@/views/user/registered.vue"),
    meta: {
      title: "注册",
    },
  },
  // 忘记密码
  {
    path: "/wjmm",
    name: "/wjmm",
    component: () => import("@/views/user/wangjimima.vue"),
    meta: {
      title: "忘记密码",
    },
  },
  // 个人中心 个人信息
  {
    path: "/pc",
    name: "/pc",
    component: () => import("@/views/user/personalCenter.vue"),
    meta: {
      title: "个人中心",
    },
  },
  {
    path: "/pchd",
    name: "/pchd",
    component: () => import("@/views/user/personalCenterhuodong.vue"),
    meta: {
      title: "活动成果",
    },
  },
];

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes,
});

export default router;
